export default __webpack_public_path__ + "static/arm_mbedstudio-ss-0791be6cb04538de13948610bbeed7b3.png";